import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerNewUser } from "../../services";
import { notify } from "../actions/CommonActions";
import { AuthContext } from "../../helpers/AuthContext";

export const NewUserModal = ({
  showUser,
  setShowUser,
  toggleShowUser,
  refetch,
}) => {
  const [register, setRegister] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    roleId: "",
  });
  const [isRegistering, setIsRegistering] = useState(false);
  const { roles, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const handleRegisterChange = (e) => {
    const name = e.target.name;
    const value = name === "roleId" ? parseInt(e.target.value) : e.target.value;
    setRegister({ ...register, [name]: value });
  };

  const registerUser = (values) => {
    setIsRegistering(true);
    // e.preventDefault();
    registerNewUser(values, user)
      .then((res) => {
        notify("success", "User Registered", res?.message);
        setShowUser(false);
        setIsRegistering(false);
        refetch();
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsRegistering(false);
      });
  };

  return (
    <Modal
      show={showUser}
      onHide={toggleShowUser}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title>New User</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form className="d-flex flex-column gap-3">
            <Row>
              <Form.Group as={Col}>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  name="firstName"
                  onChange={handleRegisterChange}
                />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Last Name</Form.Label>
                <Form.Control name="lastName" onChange={handleRegisterChange} />
              </Form.Group>
            </Row>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control name="email" onChange={handleRegisterChange} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Phone number</Form.Label>
              <Form.Control name="phoneNumber" onChange={handleRegisterChange} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Role</Form.Label>
              <Form.Select name="roleId" onChange={handleRegisterChange}>
                <option></option>
                {roles?.data?.map((role) => {
                  return (
                    <option key={role?.id} value={role?.id}>
                      {role?.name}
                    </option>
                  );
                })}
              </Form.Select>
              {/* <Form.Control name="roleId" onChange={handleRegisterChange} /> */}
            </Form.Group>
            {/* <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                name="password"
                type="password"
                onChange={handleRegisterChange}
              />
            </Form.Group> */}

            <Button
              onClick={() => {
                //   e.preventDefault();
                // console.log("reg ",register);
                registerUser(register);
              }}
              className="w-100"
              style={{ backgroundColor: "#007dcc" }}
            >
              {isRegistering ? "Registering user..." : "Sign Up"}
            </Button>
          </Form>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button
          style={{
            backgroundColor: "#007dcc",
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          Search
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};
